import React, { Component } from "react";
import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { faces_ID, faces_names } from "../../constants/faces_types";
import { getAllRacks, getWorkstations, registerTask } from "../../store/actions";
import Loader from "../Common/Loader";

class CreateTaskForm extends Component {
  constructor(props) {
    super(props);

    const { query } = this.props.location;
    if (!query) {
      this.props.history.push("/tasks");
    }

    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      popup: false,
      pop_msg: "",
      nextid: query.next_id,
      origin_page: query.page_origin,
      racks: null,
      alertType: "",
      selectedOptions: [],
      options: [],
    };
  }

  componentDidMount() {
    const { user } = this.state;
    this.props.getWorkstations(user);
    this.props.getAllRacks(user);
  }

  componentDidUpdate(prevProps) {
    this.handleTaskCreationResponse(prevProps);
    this.handleWorkstationsResponse(prevProps);
    this.handleRacksResponse(prevProps);
  }

  handleTaskCreationResponse(prevProps) {
    const { loadingCreateTask, messageTask, registrationTaskError } = this.props;
    if (!loadingCreateTask && prevProps.loadingCreateTask) {
      const taskRejectedMsg =
        registrationTaskError?.numberTasksRejected > 0 ? this.props.t("TaskRejectedCheckParameters") : "";

      this.setState({
        popup: true,
        pop_msg: messageTask
          ? this.props.t("Tarea creada correctamente")
          : `Error al crear la tarea ${taskRejectedMsg}`,
        alertType: messageTask ? "success" : "error",
      });
    }
  }

  handleWorkstationsResponse(prevProps) {
    const { loadingGetWs, ws } = this.props;
    if (!loadingGetWs && prevProps.loadingGetWs && ws) {
      if (ws.length === 0) {
        this.props.history.push("/tasks");
      } else {
        this.setState({
          options: ws.map((element) => ({ label: element.name, value: element.name })),
          ws,
        });
      }
    }
  }

  handleRacksResponse(prevProps) {
    const { loadingGetAllRacks, racks } = this.props;
    if (!loadingGetAllRacks && prevProps.loadingGetAllRacks && racks) {
      this.setState({ racks });
    }
  }

  handleValidSubmit = (event, values) => {
    const { user, selectedOptions } = this.state;

    values.workstationCandidates = selectedOptions.map((element) => element.value);
    values.estimatedDurationSeconds = values.estimatedDurationSeconds || null;
    values.token = user.token;

    this.props.registerTask(values, this.props.history);
  };

  handleChange = (selectedOptions) => {
    this.setState({ selectedOptions });
  };

  confirmPopup = () => {
    this.setState({ popup: false });
    this.props.history.push(this.state.origin_page);
  };

  renderLoader() {
    return (
      <div className="loaderCenter">
        <Loader />
      </div>
    );
  }

  renderSelectOptions(label, name, options, defaultValue, handleChange) {
    return (
      <Col>
        <FormGroup>
          <Label>{this.props.t(label)}</Label>
          <Select
            name={name}
            defaultValue={defaultValue}
            isMulti
            placeholder={this.props.t("SelectWorkstations")}
            onChange={handleChange}
            options={options}
          />
        </FormGroup>
      </Col>
    );
  }

  renderForm() {
    const { nextid, options, racks } = this.state;
    const defaultRack = racks[0]?.rackCode || "";

    return (
      <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
        <Col>
          <FormGroup>
            <Label>{this.props.t("Identificador")}</Label>
            <AvField
              value={nextid == null ? 1 : parseInt(nextid) + 1}
              name="sgtTaskid"
              placeholder="Identificador"
              type="text"
              disabled
              validate={{ required: { value: true } }}
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label>{this.props.t("Prioridad")}</Label>
            <AvInput
              name="priority"
              type="number"
              placeholder="Prioridad"
              validate={{ required: { value: true } }}
            />
          </FormGroup>
        </Col>
        {this.renderSelectOptions(
          "Estación de trabajo",
          "workstationCandidates",
          options,
          this.state.selectedOptions,
          this.handleChange
        )}
        <Col>
          <FormGroup>
            <Label>{this.props.t("Estimación de tiempo (segundos)")}</Label>
            <AvInput name="estimatedDurationSeconds" type="number" placeholder="Estimación de la tarea" />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label>{this.props.t("Racks")}</Label>
            <AvInput name="rackCode" type="select" defaultValue={defaultRack} validate={{ required: { value: true } }}>
              {racks.map((rack) => (
                <option key={rack.rackCode} value={rack.rackCode}>
                  {rack.rackCode}
                </option>
              ))}
            </AvInput>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label>{this.props.t("Cara")}</Label>
            <AvInput name="face" type="select" defaultValue={faces_ID[0]} validate={{ required: { value: true } }}>
              {faces_ID.map((face) => (
                <option key={face} value={face}>
                  {faces_names[face]}
                </option>
              ))}
            </AvInput>
          </FormGroup>
        </Col>
        <Button color="primary" type="submit" className="createButton">
          {this.props.t("Crear tarea")}
        </Button>
      </AvForm>
    );
  }

  renderAlert() {
    return (
      <SweetAlert
        type={this.state.alertType}
        title={this.state.pop_msg}
        confirmBtnText={this.props.t("ok")}
        onConfirm={this.confirmPopup}
      />
    );
  }

  render() {
    const { ws, racks, popup } = this.state;

    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t("Crear nueva tarea")}</CardTitle>
            {!ws || !racks ? this.renderLoader() : this.renderForm()}
            {popup && this.renderAlert()}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  registrationTaskError: state.CreateTask.registrationTaskError,
  messageTask: state.CreateTask.messageTask,
  loadingCreateTask: state.CreateTask.loadingCreateTask,
  loadingGetWs: state.GetWS.loadingGetWs,
  ws: state.GetWS.ws,
  loadingGetAllRacks: state.getAllRacks.loadingGetAllRacks,
  racks: state.getAllRacks.racks,
});

export default withRouter(
  connect(mapStateToProps, { registerTask, getWorkstations, getAllRacks })(withNamespaces()(CreateTaskForm))
);
